import { useState, useEffect } from 'react';
import { downloadFiles, getCustomerLeadgerData, getVendorLedgerData } from '../../Service/ApiService';
import { useNavigate } from '../../../node_modules/react-router-dom/dist/index';
import { showSuccessAlert } from 'utils/SuccessMessage';
import { showAlert } from 'utils/ErrorMessage';
const VendorLedgerController = () => {
  const [formData, setFormData] = useState({
    customer: ''
  });
  const [customeroptions, setCustomerOptions] = useState([]);
  const [ledgerData, setLedgerData] = useState([]);
  const [cloading, setcLoading] = useState(false);
  const [customerLoading, setCustomerLoading] = useState(false);

  const [isLedgerFetchPending, setIsLedgerFetchPending] = useState(false);
  const user = JSON.parse(localStorage.getItem('user'));
  const [searchText, setSearchText] = useState('');

  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    getCustomer();
  }, [searchText]);

  useEffect(() => {
    fetchLedgerData(user.userCode);
  }, []);

  useEffect(() => {
    const totalDebit = ledgerData.reduce((sum, item) => sum + parseFloat(item.debit || 0), 0);
    setTotalDebit(totalDebit);

    const totalCredit = ledgerData.reduce((sum, item) => sum + parseFloat(item.credit || 0), 0);
    setTotalCredit(totalCredit);
  }, [ledgerData]);

  useEffect(() => {
    if (!isLedgerFetchPending) {
      return;
    }

    // Hide loader only after ledgerData has been updated so the table can render first.
    setcLoading(false);
    setIsLedgerFetchPending(false);
  }, [ledgerData, isLedgerFetchPending]);

  const handleViewClick = (rowData) => {
    const ledgerData = {
      partyCode: rowData.partyCode,
      month: rowData.month,
      year: rowData.year,
      opening: rowData.opening
    };

    localStorage.setItem('ledgerData', JSON.stringify(ledgerData));

    navigate('/vendorledgerDetails');
  };

  const handleDownloadAll = async () => {
    setcLoading(true);
    const partyCode = formData.customer?.value || user.userCode;
    const param = `partyCode=${partyCode}`;

    // const param = `partyCode=1000`;
    const response = await downloadFiles(param, 'downloadAllpartyvendorLeadger.php', 'vendoroutAll.xls');
    if (response == true) {
      showSuccessAlert('File Downloaded Successfully', 'Download Ledger');
    }

    setcLoading(false);
  };

  const handleDownloadClick = async (rowData) => {
    setcLoading(true);
    const param = `partyCode=${formData.customer?.value || rowData.partyCode}&month=${rowData.month}&year=${rowData.year}&opening=${rowData.opening}`;
    const response = await downloadFiles(param, 'partyvendorledgerDownalod.php', 'vendorledgerFile.xls');
    if (response == true) {
      showSuccessAlert('Ledger File Downloaded Successfully', 'Download Ledger');
    }

    setcLoading(false);
  };

  const getCustomer = async () => {
    try {
      setcLoading(true);
      const response = await getCustomerLeadgerData(user.userCode, searchText);
      if (response && response.success === 'true') {
        setCustomerOptions([]);

        const uniqueCustomerOptions = response.customerList.reduce((uniqueList, currentItem) => {
          const existingItem = uniqueList.find((item) => item.value === currentItem.partyCode.toString());

          if (!existingItem) {
            uniqueList.push({
              value: currentItem.partyCode.toString(),
              label: currentItem.partyName + '-' + currentItem.city + '-' + currentItem.partyCode.toString()
            });
          }

          return uniqueList;
        }, []);
        setCustomerOptions(uniqueCustomerOptions);
      }
      setcLoading(false);
    } catch (error) {
      setcLoading(false);
    }
  };

  const handleInputChange = (inputValue) => {
    setSearchText(inputValue);
  };

  const handleCustomerChange = (selectedOption) => {
    if (selectedOption) {
      setFormData({
        ...formData,
        customer: selectedOption
      });
    } else {
      setFormData({
        ...formData,
        customer: null
      });

      fetchLedgerData(user.userCode);
    }
  };

  const handleSubmit = () => {
    if (formData.customer) {
      fetchLedgerData(formData.customer.value);
    } else {
      fetchLedgerData(user.userCode);
    }
  };

  const fetchLedgerData = async (customerCode) => {
    try {
      // setcLoading(true);
      setCustomerLoading(true);
      setIsLedgerFetchPending(true);

      const response = await getVendorLedgerData(customerCode);
      setLedgerData([]);
      if (response && response.success === 'true') {
        setLedgerData(response.ledgerList);
      } else {
        setLedgerData([]);
        showAlert(response.msg);
      }
      setCustomerLoading(false);
    } catch (error) {
      console.error('Error fetching ledger data:', error);
      setLedgerData([]);
      setIsLedgerFetchPending(true);
      setCustomerLoading(false);
    }
  };

  return {
    ledgerData,
    totalDebit,
    totalCredit,
    formData,
    user,
    cloading,
    customerLoading,
    customeroptions,
    handleCustomerChange,
    handleInputChange,
    handleSubmit,
    handleViewClick,
    handleDownloadAll,
    handleDownloadClick
  };
};

export default VendorLedgerController;
